<template>
  <div class="hello">
    <div class="bg">
      <img src="../assets/poker/bg2.png" />
    </div>
    <!-- <div class="msg">{{ msg }}</div> -->
    <b-form-textarea id="line" v-model="msg" rows="8"></b-form-textarea>
    <b-button class="btn" @click="sendLine()"
      ><b-icon
        icon="cloud-download"
        class="rounded-circle p-1 mr-1"
        variant="light"
      ></b-icon
      >匯出</b-button
    >
    <!-- <b-button @click="test()">Button</b-button> -->
    <div class="keyboard">
      <div class="my-row">
        <div class="unit custom" @click="key('Hero', 1)">H</div>
        <div class="unit custom" @click="key('SB', 1)">SB</div>
        <div class="unit custom" @click="key('BB', 1)">BB</div>
        <div class="unit custom" @click="key('UTG', 1)">UTG</div>
        <div class="unit custom" @click="key('MP', 1)">MP</div>
        <div class="unit custom" @click="key('HJ', 1)">HJ</div>
        <div class="unit custom" @click="key('CO', 1)">CO</div>
        <div class="unit custom" @click="key('BTN', 1)">BTN</div>
        <div class="unit" @click="deleteUnit()">
          <b-icon icon="backspace" aria-hidden="true"></b-icon>
        </div>
      </div>
      <div class="my-row">
        <div class="region-left">
          <div class="my-row">
            <div class="unit custom" @click="key('open', 1)">Open</div>
            <div class="unit custom" @click="key('bet', 1)">Bet</div>
            <div class="unit custom" @click="key('call', 1)">Call</div>
            <div class="unit custom" @click="key('fold', 1)">Fold</div>
          </div>
          <div class="my-row">
            <div class="unit custom" @click="key('check', 1)">Check</div>
            <div class="unit custom" @click="key('raise', 1)">Raise</div>
            <div class="unit custom" @click="key('All-In', 1)">All&nbsp;In</div>
          </div>

          <div class="my-row">
            <div class="unit" @click="key('♠️', 0)">♠️</div>
            <div class="unit" @click="key('♥️', 0)">♥️</div>
            <div class="unit" @click="key('♦️', 0)">♦️</div>
            <div class="unit" @click="key('♣️', 0)">♣️</div>
          </div>
          <div class="my-row">
            <div class="unit custom" @click="key('Preflop', 1)">PF</div>
            <div class="unit custom" @click="key('Flop', 1)">F</div>
            <div class="unit custom" @click="key('Turn', 1)">T</div>
            <div class="unit custom" @click="key('River', 1)">R</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('x', 0)">x</div>
            <div class="unit" @click="key('/', 0)">/</div>
            <div class="unit" @click="key('$', 0)">$</div>
            <div class="unit" @click="key('%', 0)">%</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('s', 0)">s</div>
            <div class="unit" @click="key('o', 0)">o</div>
            <div class="unit" @click="key('!', 0)">!</div>
            <div class="unit" @click="key(',', 0)">,</div>
          </div>
        </div>
        <div class="region-right">
          <div class="my-row">
            <div class="unit" @click="key('7', 0)">7</div>
            <div class="unit" @click="key('8', 0)">8</div>
            <div class="unit" @click="key('9', 0)">9</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('4', 0)">4</div>
            <div class="unit" @click="key('5', 0)">5</div>
            <div class="unit" @click="key('6', 0)">6</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('1', 0)">1</div>
            <div class="unit" @click="key('2', 0)">2</div>
            <div class="unit" @click="key('3', 0)">3</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('0', 0)">0</div>
            <div class="unit" @click="key('T', 0)">T</div>
            <div class="unit" @click="key('J', 0)">J</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('Q', 0)">Q</div>
            <div class="unit" @click="key('K', 0)">K</div>
            <div class="unit" @click="key('A', 0)">A</div>
          </div>
          <div class="my-row">
            <div class="unit" @click="key('.', 0)">.</div>
            <div class="unit" @click="key(' ', 0)">Space</div>
            <div class="unit" @click="key('\n', 0)">
              <b-icon icon="arrow-return-left" aria-hidden="true"></b-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import liff from "@line/liff";

export default {
  name: "lineRecord",
  data() {
    return {
      msg: "",
      lastCustom: 0,
    };
  },
  mounted() {
    this.liffInit();
  },
  methods: {
    key(unit, custom) {
      let input = document.getElementById("line");
      let position = input.selectionStart;
      if (custom) {
        unit = position === 0 ? unit : " " + unit;
        this.msg = [
          this.msg.slice(0, position),
          unit,
          this.msg.slice(position),
        ].join("");
        this.lastCustom = 1;
      } else {
        unit = this.lastCustom ? " " + unit : unit;
        this.msg = [
          this.msg.slice(0, position),
          unit,
          this.msg.slice(position),
        ].join("");
        this.lastCustom = 0;
      }
      let newPosition = unit.length + position;
      setTimeout(() => {
        input.focus();
        input.setSelectionRange(newPosition, newPosition);
      }, 50);
    },
    deleteUnit() {
      this.msg = this.msg.slice(0, -1);
    },
    test() {
      let input = document.getElementById("line");
      console.debug(input.selectionStart);
      input.focus();
      input.setSelectionRange(4, 4);
    },
    sendLine() {
      liff
        .sendMessages([
          {
            type: "text",
            text: this.msg,
          },
        ])
        .then(() => {
          liff.closeWindow();
        })
        .catch((error) => {
          alert(`LiffInit error: ${JSON.stringify(error)}`);
        });
    },
    liffInit() {
      liff
        .init({
          liffId: this.$route.query.id,
        })
        .then(() => {})
        .catch((error) => {
          alert(`LiffInit error: ${JSON.stringify(error)}`);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -999;
}
.bg img {
  min-height: 100%;
  width: 100%;
}
.hello {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#line {
  width: 80%;
  margin-top: 2rem;
  margin-bottom: 1rem;
  background-color: antiquewhite;
}
.btn {
  width: 80%;
  border: 1px solid black;
  background-color: gray;
  font-size: 1.2rem;
}
.msg {
  font-size: 1.6rem;
  text-align: start;
  word-wrap: break-word;
  width: 90%;
  color: black;
  background-color: burlywood;
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 1rem;
}
.keyboard {
  display: flex;
  flex-direction: column;
  padding: 0.1rem;
  background-color: #403f3f;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
}
.custom {
  background-color: aquamarine !important;
}
.my-row {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.region-left {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.region-right {
  display: flex;
  flex-direction: column;
  width: 40%;
}
.unit {
  background-color: antiquewhite;
  color: #403f3f;
  width: 100%;
  margin: 2px;
  padding-left: 1px;
  padding-right: 1px;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 4px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/lineRecord.vue